import React from "react";

class Mantra_32_Canvas extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    let { steps } = this.props;
    steps = steps ? steps : {};
    return (
      <section
        className="canvas_section mantra32_canvas setdiv_canvas"
        id={"canvas_generate_" + this.props.module_name}
      >
        <img src="/assets/img/Mantra_32.jpg" className="m3a1_img" />
        <p className="m32_prev_desc1">{steps.step1 ? steps.step1 : ""}</p>
        <p className="m32_prev_desc2">{steps.step2 ? steps.step2 : ""}</p>
        <p className="m32_prev_desc3">{steps.step3 ? steps.step3 : ""}</p>
        <p className="m32_prev_desc4">{steps.step4 ? steps.step4 : ""}</p>
        <p className="m32_prev_desc5">{steps.step5 ? steps.step5 : ""}</p>
      </section>
    );
  }
}

export default Mantra_32_Canvas;
